import { spreadListScopedRouters } from '@/utils/router'
// import space from './modules/space'
// import system from './modules/system'
// import book from './modules/book'
import platform from './modules/platform'
import order from './modules/order'
import transfer from '@/router/modules/transfer'
import confiscation from './modules/confiscation'
import deskOpen from './modules/desk-open'
import customerPrepaymentPayRecord from './modules/customer-prepayment-pay-record'
const listScopedRouters = [
  platform,
  order,
  transfer,
  confiscation,
  deskOpen,
  customerPrepaymentPayRecord
]

// 路由和路由作用域配置
const { scopeList, routerList } = spreadListScopedRouters(listScopedRouters)
const routeAsync = [
  ...routerList,
  // 404 page 需要配置在最后
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: '/404',
    hidden: true
  }
]

export { scopeList }
export default routeAsync
